// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "crn",
                Decco.stringToJson(v.crn)
              ],
              [
                "cancelled_by",
                Decco.stringToJson(v.cancelled_by)
              ],
              [
                "cancel_reason_id",
                Decco.intToJson(v.cancel_reason_id)
              ],
              [
                "order_updated_at",
                Decco.floatToJson(v.order_updated_at)
              ],
              [
                "comment",
                Decco.optionToJson(Decco.stringToJson, v.comment)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
